import { useAuth } from './auth/AuthContext';
import { useState } from 'react';
import { PageHeader, Shell } from './components/Shell';
import { NavLink, useRouter } from './lib/router';
import { AuditPage } from './pages/AuditPage';
import { BacklogPage } from './pages/BacklogPage';
import { ContentPage } from './pages/ContentPage';
import { ExperimentsPage } from './pages/ExperimentsPage';
import { HelpPage } from './pages/HelpPage';
import { LoginPage } from './pages/LoginPage';
import { MetricsPage } from './pages/MetricsPage';
import { OverviewPage } from './pages/OverviewPage';
import { ReportsPage } from './pages/ReportsPage';
import { RunsPage } from './pages/RunsPage';
import { WorkPage } from './pages/WorkPage';
import { EmailsPage } from './pages/EmailsPage';
import { ProspectsPage } from './pages/ProspectsPage';
import { PreviewsPage } from './pages/PreviewsPage';
import { CRMPage } from './pages/CRMPage';
import { CampaignsPage } from './pages/CampaignsPage';
import { SettingsPage } from './pages/SettingsPage';

export function App() {
  const { capabilities, isLoading, user, logout } = useAuth();
  const [logoutFailed, setLogoutFailed] = useState(false);
  const { pathname } = useRouter();
  if (isLoading && !user) return <div className="boot-screen" role="status"><span className="brand__mark">LE</span><strong>Loading secure console…</strong></div>;
  if (!user) return <LoginPage />;
  if (!capabilities.view) return <div className="boot-screen boot-screen--access" role="alert"><span className="brand__mark">LE</span><strong>Your account does not have GTM Console access.</strong><button className="button" disabled={isLoading} onClick={() => { setLogoutFailed(false); void logout().catch(() => setLogoutFailed(true)); }}>Log out and use another account</button>{logoutFailed ? <p>Log out failed. Check your connection and try again.</p> : null}</div>;
  const pages: Record<string, JSX.Element> = {
    '/': <OverviewPage />, '/metrics': <MetricsPage />, '/runs': <RunsPage />,
    '/reports': <ReportsPage />, '/experiments': <ExperimentsPage />,
    '/work': <WorkPage />,
    '/emails': <EmailsPage />,
    '/prospects': <ProspectsPage />,
    '/crm': <CRMPage />,
    '/relationships': <CRMPage />,
    '/campaigns': <CampaignsPage />,
    '/settings': <SettingsPage />,
    '/publishing': <ContentPage />,
    '/activity': <AuditPage />,
    '/previews': <PreviewsPage />,
    '/backlog': <BacklogPage />, '/content': <ContentPage />, '/audit': <AuditPage />, '/help': <HelpPage />
  };
  return <Shell>{pages[pathname] || <section className="route-not-found"><PageHeader title="Page not found" description="This link does not match a GTM page. Choose a section from the navigation or return to Today." /><nav aria-label="Page recovery"><NavLink className="button" to="/">Go to Today</NavLink><NavLink className="button button--quiet" to="/help">Open help</NavLink></nav></section>}</Shell>;
}
